"use client";
import React from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "react-headless-accordion";
import BarFooter from "@/src/components/BarFooter";
import Link from "next/link";
import BarTop from "@/src/components/BarTop";

export default function PageFAQ() {
  return (
    <div className="Pages">
              <BarTop />
      <div className="Wrapper">
        <h1 className="terms-header">FREQUENTLY ASKED QUESTIONS</h1>
        <p></p>
        <div className="BoxPage">
          {/* <h2>General Questions</h2> */}
          <>
            <p>
              Below are some of the most frequently asked questions. In case you
              cannot find the answer to your question on this page, do not
              hesitate to contact our support team via live chat.
            </p>
            <Accordion>
              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    1. What is Goat Spins?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Goat Spins is an online casino that offers a wide range of
                      slot games and other casino entertainment options.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    2. How do I create an account at Goat Spins?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      To create an account, click on the &apos;Sign Up&apos; or &apos;Register&apos;
                      button on our homepage. Fill in the required information,
                      and your account will be created.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    3. What games are available at Goat Spins?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      We offer a diverse selection of slot games, including
                      classic slots, video slots, progressive jackpot slots, and
                      more. Additionally, you can enjoy table games, and certain
                      specialty games. The entire list is visible when you log
                      in.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    4. How can I deposit funds into my account?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      You can deposit funds using various cryptocurrency payment
                      methods such as Bitcoin, Litecoin, Ethereum, Tether,
                      Binance.
                    </p>

                    {/* <p>
                      • Live Chat: Our live chat feature allows you to connect
                      with a support representative in real-time. Simply click
                      on the{" "}
                      <button
                        onClick={() => Tawk_API.maximize()}
                        className="Links"
                      >
                        chat icon
                      </button>{" "}
                      on our website to initiate a conversation.
                    </p> */}
                    {/* <p>
                      • Email Support: For non-urgent matters or detailed
                      inquiries, you can send us an email at{" "}
                      <Link
                        href="mailto:support@eternalslots.com"
                        className="Links"
                      >
                        support@eternalslots.com
                      </Link>{" "}
                      . Our support team strives to respond promptly to all
                      emails.
                    </p> */}
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* <h2>Account and Verification</h2> */}

              {/* <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    How do I create an account at eternal slots?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Creating an account is a simple and straightforward
                      process. Follow these steps to get started:
                    </p>

                    <p>
                      1) Visit our website: Go to our official website at
                      www.eternalslots.com.{" "}
                    </p>
                    <p>
                      2) Click on 'Sign Up': Locate the 'Sign Up' or 'Register'
                      button on the homepage and click on it.{" "}
                    </p>
                    <p>
                      3) Fill in the Registration Form: Provide the required
                      information, including your email address, a strong
                      password, and any other necessary details
                    </p>
                    <p>
                      4) Verify Your Account: After completing the registration
                      form, you may be required to verify your account. Check
                      your email for a verification link or code and follow the
                      instructions provided.{" "}
                    </p>

                    <p>
                      5) Log In: Once your account is verified, return to the
                      website and log in using your newly created credentials.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    What security measures does eternal slots have in place to
                    protect my information?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      eternal slots employs state-of-the-art SSL encryption to
                      secure all user data. Additionally, our platform undergoes
                      regular security audits, and we adhere to strict privacy
                      policies to ensure the confidentiality and integrity of
                      your personal information.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    How do I reset my password if I forget it?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      To reset your password, click on the "Forgot Password"
                      link on the login page. Follow the instructions sent to
                      your registered email to create a new password. If you
                      encounter any issues, contact our {""}
                      <Link href="/support" className="Links">
                        support team
                      </Link>{" "}
                      {""}
                      for assistance.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    Is it possible to have multiple accounts?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      No, you are restricted to having just one account
                      throughout your lifetime. Even if a previous account is
                      closed, reactivation must be requested, as the creation of
                      new accounts is not allowed.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    What kind of documentation is necessary for the account
                    verification?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      We may request specific documentation to ensure the
                      security and integrity of our platform. Typically, the
                      required documents include:
                    </p>
                    <p>
                      • Proof of Identity: A government-issued ID card,
                      passport, or driver's license displaying your full name
                      and photo.{" "}
                    </p>
                    <p>
                      • Proof of Address: A recent utility bill, bank statement,
                      or official document that confirms your residential
                      address. It should be dated within the last three months.
                    </p>
                    <p>
                      • Payment Method Verification: In some cases, we may ask
                      for documentation confirming the ownership of the payment
                      methods used, such as a photo or scan of the credit card
                      (with sensitive information securely obscured) or proof of
                      ownership for an e-wallet.
                    </p>

                    <p>
                      All these documents should be provided on the following
                      email address:{" "}
                      <Link
                        href="mailto:banking@eternalslots.com"
                        className="Links"
                      >
                        banking@eternalslots.com
                      </Link>{" "}
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    How can I ensure the maximum security for my account?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      To ensure the utmost security for your account at Eternal
                      Slots, consider the following precautions:
                    </p>

                    <p>
                      • Use a strong password: Create a unique and strong
                      password that combines letters, numbers, and special
                      characters. Avoid easily guessable information such as
                      birthdays or common words.
                    </p>
                    <p>
                      • Enable Two-Factor Authentication (2FA): Activate 2FA for
                      an additional layer of security. This typically involves
                      receiving a code on your mobile device or email that you
                      must enter along with your password during login.
                    </p>
                    <p>
                      • Regularly Update Passwords: Change your password
                      periodically to reduce the risk of unauthorized access.
                      Avoid using the same password across multiple platforms.
                    </p>
                    <p>
                      • Keep Your Email Secure: Ensure that the email account
                      associated with your eternal slots account is secure. Use
                      a strong password for your email and consider enabling
                      2FA.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* <h2>Deposit and Withdrawals</h2> */}

              {/* <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    How can I ensure the maximum security for my account?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      eternal slots offers a variety of deposit options,
                      including Bitcoin, Litecoin, Ethereum and other popular
                      cryptocurrencies. Visit our{" "}
                      <Link href="/banking" className="Links">
                        banking page
                      </Link>{" "}
                      or a comprehensive list and details on each method.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    How can I make a deposit?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      To make a deposit at eternal slots, follow these simple
                      steps:
                    </p>

                    <p>
                      • Log In: Fill the form to your eternal slots account
                      using your credentials.
                    </p>
                    <p>
                      • Navigate to the Deposit Section: Once logged in, locate
                      the 'Deposit' or 'Cashier' section. This is typically
                      found in the main menu or on your account dashboard.
                    </p>
                    <p>
                      • Choose Your Payment Method: Select your preferred
                      deposit method from the available options. eternal slots
                      supports various payment methods, including credit/debit
                      cards, e-wallets, bank transfers, and other secure
                      options.
                    </p>
                    <p>
                      • Enter Deposit Amount: Specify the amount you wish to
                      deposit. Ensure it adheres to any minimum or maximum
                      deposit limits imposed by the platform or your chosen
                      payment method.
                    </p>
                    <p>
                      • Complete the Transaction: Follow the on-screen
                      instructions to complete the transaction. You may be
                      redirected to a secure payment gateway or prompted to
                      enter additional information.
                    </p>
                    <p>
                      • Verify the Transaction: In some cases, you may need to
                      confirm the deposit through email verification or
                      two-factor authentication for added security.
                    </p>
                    <p>
                      • Confirmation: Once the deposit is successfully
                      processed, you should receive a confirmation message. Your
                      account balance will be updated to reflect the deposited
                      amount, and you can begin enjoying the exciting games at
                      eternal slots.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem> */}

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    5. Are there any fees for deposits or withdrawals?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Goat Spins Casino does not charge any fees for deposits or
                      withdrawals. However, please check with your payment
                      provider as they may apply their own fees.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    6. How can I withdraw my winnings?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Withdrawals are processed to the same account from which
                      the deposit originated. Goat Spins pays out the players in
                      Bitcoin, Litecoin or Tether.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    7. What steps should I take to withdraw my winnings?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      To request a withdrawal, click on the &quot;Cashier&quot; button,
                      then navigate to the &apos;Withdraw&apos; tab at the top of the
                      screen. If needed, our Customer Service team is available
                      24/7 to assist you with this process. Please note that in
                      case you wish to withdraw after using a non-deposit bonus,
                      and you haven&apos;t had a prior deposit history, we would
                      require a verification deposit of min. USDT10, which you
                      will be obliged to withdraw along with your winning
                      amount.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    8. Are there any withdrawal limits?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      The specific limits may vary depending on your chosen
                      withdrawal method and your player status. The standard
                      weekly withdrawal limit is USDT 4,000. Please refer to our
                      Terms and Conditions or contact customer support for
                      detailed information.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* <h2>Casino Bonuses and Special Offers</h2> */}

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    9. Is my personal information safe at Goat Spins?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Goat Spins takes the security and privacy of your personal
                      information seriously. We use advanced encryption
                      technology and apply strict data protection rules to
                      ensure your information remains secure at all times.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    10. How can I contact customer support?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Our customer support team is reachable 24/7 via live chat
                      bubble on the website, or via email:
                      support@goatspins.com. Feel free to contact them at all
                      times to assist you with any inquiries or issues you may
                      have.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    11. Can I play at Goat Spins from my mobile device?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Yes, Goat Spins is fully optimized for mobile play. You
                      can access our casino and enjoy a seamless gaming
                      experience on your smartphone or tablet.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    12. Does Goat Spins offer bonuses and promotions?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Yes, we offer a variety of bonuses and promotions,
                      including welcome bonuses for new players, specially
                      crafted offers for depositors, loyalty rewards and many
                      other. Check our Promotions page as well as your inbox
                      regularly for the latest offers.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    13. What is the minimum age requirement to play at Goat
                    Spins?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      You must be at least 18/21 years old (or the legal age for
                      gambling in your jurisdiction) to play at Goat Spins.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    14. Can I self-exclude or set limits on my gambling
                    activities?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Yes, we offer tools that promote responsible gaming. If
                      you are interested to learn more, contact customer support
                      for assistance.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* <h2>VIP Program</h2> */}
              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    15. Are players from all countries accepted at Goat Spins?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Make sure to check our Terms and Conditions or contact
                      customer support to confirm if you can play from your
                      location. In general, we accept players from many
                      countries, but there are some restricted jurisdictions due
                      to legal restrictions.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    16. What should I do if I forget my password?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      No worries. In case you forget your password and cannot
                      find your way around the website, contact the live support
                      team and they can assist and send instructions on
                      resetting the password.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              {/* <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    Are there different levels within the VIP program?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Yes, the VIP program at eternal slots consists of multiple
                      levels, each offering increasing benefits and privileges.
                      Advancement through these levels is typically based on
                      your level of activity, loyalty, and overall gameplay. The
                      higher the level, the more exclusive the perks.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    What is the role of comp points in VIP program?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      Comp points not only enhance the gaming experience but
                      also contribute to a player's overall VIP status within
                      the loyalty program. The more comp points you accumulate,
                      the higher your status, unlocking additional privileges
                      and perks. It's a way for casinos to express appreciation
                      for player loyalty and provide added value for consistent
                      and enthusiastic participation in their gaming platform.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem>
                <AccordionHeader className="AccordionHeader">
                  <div className={`accordion-title`}>
                    Can I transfer my VIP status to another account?
                  </div>
                </AccordionHeader>
                <AccordionBody className="AccordionBody">
                  <div className="accordion-body">
                    <p>
                      VIP status is non-transferable between accounts. It is
                      tied to the individual account and reflects that account's
                      activity and loyalty. If you have specific inquiries about
                      your VIP status, feel free to contact our customer support
                      for personalized assistance.
                    </p>
                  </div>
                </AccordionBody>
              </AccordionItem> */}

              {/* END ACCORDION */}
            </Accordion>
          </>
        </div>
      </div>
      {/* <BarFooter /> */}
    </div>
  );
}
